export default __webpack_public_path__ + "static/media/ad-popup.0917e875.png";